import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WFactsCCD: IClientComponentDefinition = {
  name: 'WFacts',
  load: () => import(/* webpackChunkName: 'WFacts' */ './index'),
}
